import React from 'react';
import styled from 'styled-components';

const WizardFooter = styled.div`
  position: sticky;
  bottom: -32px;
  z-index: 10;
  margin-top: auto !important;
`;

type FooterProps = {
  children: React.ReactNode;
};

const Footer = ({ children }: FooterProps) => (
  <WizardFooter className="btn-container">{children}</WizardFooter>
);

export default Footer;
